import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';
import { ILocationSearchParams } from './models';

export const setZoomTypeIndex = createAction(types.SET_ZOOM_TYPE_INDEX);
export const getMatchedLocations = createApiAction<ILocationSearchParams>(
	types.GET_MATCHED_LOCATIONS,
);
export const resetMatchedLocations = createAction(
	types.RESET_MATCHED_LOCATIONS,
);
export const setIsLocationSearchForOffice = createAction(
	types.SET_IS_LOCATION_SEARCH_FOR_OFFICE,
);
export const resetIsLocationSearchForOffice = createAction(
	types.RESET_IS_LOCATION_SEARCH_FOR_OFFICE,
);
export const setIsLocationChanged = createAction(types.SET_IS_LOCATION_CHANGED);
